import React from 'react';
import { connect } from 'react-redux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { match } from 'react-router-dom';

// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas, FormPickerDatas } from '../../../local-types';
import { AutoFill } from '../../../components/field-autofill';
// Modules
import { selectors as errorsSelectors, ErrorPayload } from '../../../redux/reducers/errors';
import {
    actions as companyActions,
    selectors as companySelectors,
    types as companyTypes,
    CompanyById,
} from '../../../redux/reducers/companies';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
// Ressources
import styles from './contract-edit-style';
import ObjectUtils from '../../../utils/objectUtils';
import UserUtils, { AccountRight, RightRank } from '../../../utils/userUtils';
import DateUtils from '../../../utils/dateUtils';
import { paths } from '../../paths';
import { Industry, TParams } from '../../../redux/reducers/api-types';
import StringUtils from '../../../utils/stringUtils';
import { getFindUsersAccountManagerURL } from '../../../utils/core-api';

interface ContractEditPageProps extends WithTranslation, WithStyles {
    match: match<TParams>;
    companies: CompanyById;
    industries: Industry[];
    getCompany: (id: string) => any;
    editCompany: (id: string, payload: any) => any;
    getCompanyIndustries: () => any;
    getContractError: ErrorPayload;
    getEditCompanyNewError: ErrorPayload;
    isEditingContract: boolean;
}

interface ContractEditPageState {
    formData: any;
}

class ContractEditPage extends React.Component<ContractEditPageProps, ContractEditPageState> {
    optionsCostCenter: FormPickerDatas[];

    constructor(props: ContractEditPageProps) {
        super(props);
        this.state = {
            formData: {},
        };
    }

    static getDerivedStateFromProps(props: ContractEditPageProps, state) {
        const id = props.match.params.id;
        const payload = props.companies[id];
        if (payload) {
            console.log(payload);
            return { formData: payload };
        }
        return null;
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const company = this.props.companies[id];
        const industries = this.props.industries;
        if (!company) {
            this.props.getCompany(id);
        }
        if (!industries?.length) {
            this.props.getCompanyIndustries();
        }
    }

    handleSubmit = (formData, event): void => {
        const { editCompany, match } = this.props;
        const id = match.params.id;
        this.setState({ formData: formData });
        console.log({ formData });

        const payload = {
            name: formData.name,
            uuid_account_manager: formData.account_manager?.id ?? formData.account_manager?.uuid,
            uuid_industry: formData.industry?.uuid,
        };

        // let payload = { ...formData };
        // [
        //     'id_contract',
        //     'created_at',
        //     'id_plan',
        //     'dispatch_group_authorizations',
        //     'documents',
        //     'extras_list',
        //     'history',
        //     'management_fee',
        //     'management_fee_old',
        //     'nb_bookings',
        //     'nb_users',
        //     'pricing_sets',
        //     'total_net_price_without_vat',
        //     'total_net_price_without_vat_generated_recently',
        // ].forEach((e) => delete payload[e]);

        // if (!payload.recipient_type) {
        //     payload.recipient_type = '';
        // } else {
        //     payload.recipient_type = 'cost_center';
        // }

        // if (payload.airplus && payload.airplus.expiry_date.split('-').length < 3) {
        //     payload.airplus.expiry_date = DateUtils.dateFormat(
        //         formData.default_billing_month_payments?.expiry_date,
        //         'yyyy-mm-dd',
        //     );
        // }

        console.log(payload);
        editCompany(id, payload);
    };

    inputsBuilder = (): FormDatas[] => {
        const { t, industries } = this.props;
        const formPayload = this.state.formData;

        const now = new Date();

        const isDepartment = formPayload.parent?.id;
        const isAccountManager =
            (formPayload.account_manager && UserUtils.getUser().user?.id === formPayload.account_manager?.id) ?? false;

        // this.optionsCostCenter = formPayload.cost_centers
        //     ? formPayload.cost_centers
        //           .filter((c) => c.active)
        //           .map((c) => {
        //               let name = c.name;
        //               if (c.description) {
        //                   name = `${name} (${c.description})`;
        //               }
        //               return {
        //                   id: c.id,
        //                   name,
        //               };
        //           })
        //     : [];

        const industryOptions: FormPickerDatas[] = industries;

        // const paiementPolicyOptions: FormPickerDatas[] = [
        //     { id: 'central', name: t('paiement.central') },
        //     { id: 'individual', name: t('paiement.individual') },
        // ];

        // const paiementOptions: FormPickerDatas[] = [
        //     { id: 'mensual', name: t('paiement.mensual') },
        //     { id: 'unitary', name: t('paiement.unitary') },
        // ];

        // const paiementMensualOptions: FormPickerDatas[] = [
        //     { id: 'wire_transfer', name: t('paiement.transfert') },
        //     { id: 'sepa', name: t('paiement.sepa') },
        //     { id: 'airplus', name: t('paiement.airplus') },
        //     ...(formPayload.cards
        //         ? formPayload.cards
        //               .map((c) => {
        //                   c.name = `${t('paiement.cb')} ${c.maskedNumber}`;
        //                   return c;
        //               })
        //               .flat()
        //         : {}),
        // ];

        const formsData: FormDatas[] = [
            {
                title: t('common:form.general_infos'),
                datas: [
                    { id: 'name', label: t('common:form.lastname'), required: true },
                    // { id: 'siren', label: t('siren') },
                    // { id: 'activation_date', label: t('activation_date'), type: 'date' },
                    {
                        id: 'industry.uuid',
                        label: t('industry'),
                        noEmpty: true,
                        required: true,
                        options: industryOptions,
                    },
                    {
                        id: 'account_manager',
                        label: t('account_manager'),
                        customView: (val, handleChange) => {
                            return (
                                <AutoFill
                                    formControl={false}
                                    datas={{
                                        id: 'account_manager',
                                        name: 'account_manager',
                                        label: t('account_manager'),
                                        minChar: 1,
                                        isUuid: true,
                                        variant: 'outlined',
                                        style: { marginLeft: '16', paddingRight: 32 },
                                        defaultValue: val ? { id: val.uuid, name: StringUtils.userFullname(val) } : val,
                                        required: false,
                                        onChange: (idc, text, item, list, event) => {
                                            handleChange(event, item);
                                        },
                                        loaderPosition: 'right',
                                        api: getFindUsersAccountManagerURL(),
                                    }}
                                />
                            );
                        },
                    },
                ],
            },
            // {
            //     title: t('billing_infos'),
            //     datas: [
            //         { id: 'corporate_name', label: t('corporate_name') },
            //         { id: 'contract_number', label: t('contract_number') },
            //         { id: 'purchase_order', label: t('purchase_order') },
            //         { id: 'vat_number', label: t('vat_number') },
            //         { id: 'billing_emails', label: t('accountants_mail'), hint: t('accountants_mail_hint') },
            //         { id: 'recipient_type', label: t('billing_cost_center'), type: 'boolean' },
            //         {
            //             id: 'send_bill_export',
            //             label: t('send_bill_export'),
            //             hint: !isAccountManager ? t('send_bill_export_hint') : null,
            //             type: 'boolean',
            //             disable: !isAccountManager,
            //         },
            //     ],
            // },
            // {
            //     title: t('billing_address'),
            //     datas: [
            //         {
            //             id: 'billing_address[street]',
            //             label: t('common:form.address.street'),
            //             required: !isDepartment,
            //         },
            //         {
            //             id: 'billing_address[postal_code]',
            //             label: t('common:form.address.postal_code'),
            //             required: !isDepartment,
            //         },
            //         {
            //             id: 'billing_address[city]',
            //             label: t('common:form.address.city'),
            //             required: !isDepartment,
            //         },
            //         {
            //             id: 'billing_address[country]',
            //             label: t('common:form.address.country'),
            //             required: !isDepartment,
            //         },
            //     ],
            // },
            // {
            //     title: t('paiement.title'),
            //     datas: [
            //         {
            //             id: 'grouped_payment_allowed',
            //             label: t('grouped_payment_allowed'),
            //             type: 'boolean',
            //         },
            //         {
            //             id: 'centralized_payment',
            //             label: t('payment_policy'),
            //             noEmpty: true,
            //             options: paiementPolicyOptions,
            //         },
            //         {
            //             id: 'centralized_payment_mode',
            //             label: t('centralized_payment_mode'),
            //             noEmpty: true,
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //             ],
            //             hint: t('paiement.centralized_payment_mode_hint'),
            //             options: paiementOptions,
            //         },
            //         {
            //             id: 'centralized_mensual_payment_mode',
            //             label: t('centralized_mensual_payment_mode'),
            //             noEmpty: true,
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //                 { id: 'centralized_payment_mode', value: 'mensual' },
            //             ],
            //             options: paiementMensualOptions,
            //         },
            //         {
            //             id: 'airplus[card_number]',
            //             required: true,
            //             defaultValue: formPayload.default_billing_month_payments?.card_number,
            //             placeholder: t('paiement.airplus_details.card_number_placeholder'),
            //             hint: t('paiement.airplus_details.card_number_hint'),
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //                 { id: 'centralized_payment_mode', value: 'mensual' },
            //                 { id: 'centralized_mensual_payment_mode', value: 'airplus' },
            //             ],
            //             inputsAttributs: { pattern: '^[0-9]{15,16}$' },
            //             label: t('paiement.airplus_details.card_number'),
            //         },
            //         {
            //             id: 'airplus[expiry_date]',
            //             type: 'month',
            //             required: true,
            //             defaultValue: DateUtils.dateFormat(
            //                 formPayload.default_billing_month_payments?.expiry_date,
            //                 'yyyy-mm',
            //             ),
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //                 { id: 'centralized_payment_mode', value: 'mensual' },
            //                 { id: 'centralized_mensual_payment_mode', value: 'airplus' },
            //             ],
            //             inputsAttributs: {
            //                 min: DateUtils.dateFormat(now, 'yyyy-mm'),
            //                 max: DateUtils.dateFormat(
            //                     DateUtils.getNextMonth(new Date(now.getFullYear() + 5, now.getMonth(), 1)),
            //                     'yyyy-mm',
            //                 ),
            //             },
            //             dateOutputFormat: 'yyyy-mm-dd',
            //             label: t('paiement.airplus_details.expiration_date'),
            //         },
            //         {
            //             id: 'sepa[name]',
            //             required: true,
            //             defaultValue: formPayload.default_billing_month_payments?.sepa_holder_name || formPayload.name,
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //                 { id: 'centralized_payment_mode', value: 'mensual' },
            //                 { id: 'centralized_mensual_payment_mode', value: 'sepa' },
            //             ],
            //             label: t('paiement.sepa_details.name'),
            //         },
            //         {
            //             id: 'sepa[iban]',
            //             required: true,
            //             defaultValue: formPayload.default_billing_month_payments?.sepa_iban,
            //             placeholder: t('paiement.sepa_details.iban_placeholder'),
            //             hint: t('paiement.sepa_details.iban_hint'),
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //                 { id: 'centralized_payment_mode', value: 'mensual' },
            //                 { id: 'centralized_mensual_payment_mode', value: 'sepa' },
            //             ],
            //             inputsAttributs: { pattern: '^[A-Z]{2}[0-9A-Z]{25}$' },
            //             label: t('paiement.sepa_details.iban'),
            //         },
            //         {
            //             id: 'sepa[rum]',
            //             required: true,
            //             defaultValue: formPayload.default_billing_month_payments?.sepa_rum,
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //                 { id: 'centralized_payment_mode', value: 'mensual' },
            //                 { id: 'centralized_mensual_payment_mode', value: 'sepa' },
            //             ],
            //             label: t('paiement.sepa_details.rum'),
            //         },
            //         {
            //             id: 'sepa[contract_signing_date]',
            //             required: true,
            //             defaultValue: formPayload.default_billing_month_payments?.sepa_signature_date,
            //             disableTimestampConvertion: true,
            //             linked: [
            //                 { id: 'grouped_payment_allowed', value: true },
            //                 { id: 'centralized_payment', value: 'central' },
            //                 { id: 'centralized_payment_mode', value: 'mensual' },
            //                 { id: 'centralized_mensual_payment_mode', value: 'sepa' },
            //             ],
            //             type: 'date',
            //             label: t('paiement.sepa_details.contract_signing_date'),
            //         },
            //         {
            //             id: 'obp_webapp',
            //             label: t('obp_webapp'),
            //             type: 'boolean',
            //             linked: [{ id: 'centralized_payment', value: 'central' }],
            //             hint: t('obp_webapp_hint'),
            //         },
            //     ],
            // },
            // {
            //     title: t('trip_policy'),
            //     datas: [
            //         {
            //             id: 'book_for_others',
            //             label: t('book_for_others'),
            //             type: 'boolean',
            //         },
            //         {
            //             id: 'default_cost_center[id]',
            //             label: t('default_cost_center'),
            //             options: this.optionsCostCenter,
            //         },
            //         {
            //             id: 'cost_center_mandatory',
            //             label: t('cost_center_mandatory'),
            //             type: 'boolean',
            //         },
            //         {
            //             id: 'ride_reason_mandatory',
            //             label: t('ride_reason_mandatory'),
            //             type: 'boolean',
            //         },
            //         {
            //             id: 'analytics_reference_enabled',
            //             label: t('analytics_reference_enabled'),
            //             type: 'boolean',
            //             hint: t('analytics_reference_hint'),
            //         },
            //     ],
            // },
            // {
            //     title: t('default_booking_address'),
            //     datas: [
            //         {
            //             id: 'default_booking_address[street]',
            //             label: t('common:form.address.street'),
            //         },
            //         {
            //             id: 'default_booking_address[postal_code]',
            //             label: t('common:form.address.postal_code'),
            //         },
            //         {
            //             id: 'default_booking_address[city]',
            //             label: t('common:form.address.city'),
            //         },
            //         {
            //             id: 'default_booking_address[country]',
            //             label: t('common:form.address.country'),
            //         },
            //     ],
            // },
        ];

        return formsData;
    };

    render() {
        const { match, getContractError, getEditCompanyNewError, isEditingContract } = this.props;
        const id = match.params.id;
        const formPayload = this.state.formData;

        return (
            <App needRights={{ name: AccountRight.COMPANY_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={getContractError || getEditCompanyNewError} />
                {!ObjectUtils.isEmpty(formPayload) && (
                    <>
                        <EnhancedForm
                            payload={formPayload}
                            inputs={this.inputsBuilder()}
                            backRoute={`${paths.contracts}/${id}`}
                            onSubmit={this.handleSubmit}
                            loader={isEditingContract}
                        />
                    </>
                )}
            </App>
        );
    }
}

const ContractEditPageWithStyleAndTranslation = withStyles(styles)(
    withTranslation(['company', 'common'])(ContractEditPage),
);

const mapStateToProps = (state) => ({
    companies: companySelectors.getCompaniesNew(state),
    industries: companySelectors.getIndustriesNew(state),
    getContractError: errorsSelectors.getContractError(state),
    getEditCompanyNewError: errorsSelectors.getEditCompanyNewError(state),
    isEditingContract: pendingSelectors.isPending(state, companyTypes.EDIT_CONTRACT),
});

const mapDispatchToProps = {
    getCompany: companyActions.getCompanyNew,
    editCompany: companyActions.editCompanyNew,
    getCompanyIndustries: companyActions.getCompanyNewIndustries,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractEditPageWithStyleAndTranslation);
